import { Component } from '@angular/core';

@Component({
    selector: 'app-icon-access-key',
    templateUrl: './icon-access-key.component.pug',
    styleUrls: ['./icon-access-key.component.less']
})
export class IconAccessKeyComponent {
    value: string = '';

    constructor(
    ) {
    }

    setValue(value: any) {
        this.value = value.toString();
    }
}
